import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
// import { useNavigate, useLocation, useParams } from "react-router-dom";
import { makeApiCall } from '../../../config';
import PlanCard from '../Components/PlanCard';
import PricingPage from '../PricingPage';


// Load your Stripe public key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
const options = {
  mode: 'subscription',
  amount: 1,
  currency: 'inr'
};
const CheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectPlan, setSelectPlan] = useState({
    amount: 0,
    planType: '',
    enableAnnualPlan: false,
    enableMonthlyPlan: false
  });

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    if (!stripe || !elements) {
      setError("please try after some times");
      setLoading(false);
      return;
    }

    if (selectPlan.amount == 0 || !selectPlan.planType) {
      setError("please select a plan");
      setLoading(false);
      return;
    }

    // const cardElement = elements.getElement(CardElement);
    // const { error, token } = await stripe.createToken(cardElement);
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement),
    });


    if (error) {
      setError(error.message);
      setLoading(false);
    }
    if (!error) {
      // Send token to your server
      const { id } = paymentMethod;
      const amntInRupees = selectPlan.amount * 83.51;
      const response = await makeApiCall("/payment-gateway/charge", "POST", {
        amount: amntInRupees,
        token: id,
        planType: selectPlan.planType
      });
      if (response.ok) {
        // Handle successful payment
        console.log('Payment successful');
      } else {
        // Handle payment failure
        console.error('Payment failed');
      }

      setLoading(false);
    }
  };

  const handlePlanChange = (plan, amount, title) => {
    if (title === "Monthly") {
      setSelectPlan((prev) => ({
        planType: title,
        amount,
        enableAnnualPlan: false,
        enableMonthlyPlan: true
      }));
    }
    if (title === "Annual") {
      setSelectPlan((prev) => ({
        planType: title,
        amount,
        enableAnnualPlan: true,
        enableMonthlyPlan: false
      }));

    }
  }

  return (<>
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 grid-cols-1 mt-10 mb-12 gap-10">
          <div className="lg:order-1 order-2 flex flex-col justify-center">
            <div className="flex flex-col gap-16 pr-10">

              <div className="flex">
                <div className="w-18 mr-6 flex-shrink-0">
                  <img src="https://cdn.convertkit.com/assets/images/creator_network_green.svg" alt="" className="-mt-2"
                    width="80" height="80" />
                </div>
                <div className="flex-grow">
                  <h3 className="text-lg font-semibold mb-3">Get a better experience with milir Saas</h3>
                  <p className="text-sm">Grow your business faster with no extra effort. Milir
                    Recommendations allow you to track your user with appropriate analytics.</p>
                </div>
              </div>

            </div>
          </div>
          <div className="p-10 relative lg:order-2 order-1 bg-white border rounded border-gray-200">
            <div className="mb-10">
              <div className="grid grid-flow-row auto-rows-fr gap-4 mb-5 lg:grid-cols-2 lg:gap-10">

                <PlanCard title={"Monthly"} plan={"month"} amount={"15"} style={selectPlan.enableMonthlyPlan} handlePlanChange={handlePlanChange} />
                <PlanCard title={"Annual"} plan={"year (2 month free)"} amount={"60"} style={selectPlan.enableAnnualPlan} handlePlanChange={handlePlanChange} />

              </div>
            </div>
            <section className="card-form">
              <div className="form-group">
                <form onSubmit={handleSubmit}>
                  <div className="row mb-4">
                    <div className="col-sm-6">
                      <label for="cc-number" className="w-full font-semibold"> Card Number
                        <div id="cc-number"
                          className="mt-1 border rounded-sm p-3 StripeElement StripeElement--empty">
                          <CardElement id="card-element" className="block w-[32rem] rounded-lg border border-gray-300 bg-gray-50 p-2.5 pe-10 text-sm text-gray-900 focus:border-primary-500 focus:ring-primary-500  dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder:text-gray-400 dark:focus:border-primary-500 dark:focus:ring-primary-500" />
                          {error && <div id="card-errors" className=' text-red-500'>{error}</div>}
                        </div>
                      </label>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-12">
                      <button
                        type="submit"
                        disabled={!stripe || loading}
                        className="w-full cursor-default border border-solid border-transparent no-underline font-sans font-semibold transition duration-200 hover:no-underline focus:no-underline focus:outline-none text-sm py-2 px-4 rounded bg-indigo-600 text-white text-opacity-85 bg-opacity-75 focus:outline-blue"
                      >{loading ? 'Processing...' : 'Submit Card'}</button>
                    </div>
                  </div>
                </form>
              </div>
            </section>

            <div className="mt-10">You will be billed <span className="font-semibold">$290</span> (plus applicable tax) on
              July 3 each year starting at the end of your free trial on <span className="font-semibold">July 3,
                2024</span>.</div>

          </div>
        </div>
        <PricingPage handlePlanChange={handlePlanChange} />
      </div> 
    </div>
  </>
  );
};

const StripeCheckoutForm = () => (
  <Elements stripe={stripePromise} options={options}>
    <CheckoutForm />
  </Elements>
);

export default StripeCheckoutForm;
